import { Auth } from '@aws-amplify/auth';
import config from '../../config';
import { getAxiosClient } from '../aws/api-gateway/axiosClient/axiosClientWithInterceptor';
import HttpApiGateway from '../aws/api-gateway/HttpApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const { REACT_APP_AWS_DEFAULT_REGION: region = 'ap-southeast-2', REACT_APP_PROJECT_CODE: projectCode, REACT_APP_DEPLOYMENT_STAGE: stage } = process.env;
const host = `wideawake.${config.internalAccountDomain}`;
export const getServerInfo = async () => {
    const path = '/serverInfo';
    const serverInfoRes = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return serverInfoRes;
};
export const getItems = async ({ objectTypeId }) => {
    const path = `/${objectTypeId}`;
    const res = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return res;
};
export const getItem = async ({ Item }) => {
    const path = `/getItem`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: { Item },
    });
    return res;
};
export const putItems = async ({ Items }) => {
    const path = `/putItems`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: { Items },
    });
    return res;
};
export const queryByGraph = async (request) => {
    const path = '/queryByGraph';
    const res = await HttpApiGateway.post({
        host,
        path,
        data: request,
    });
    return res;
};
export const getItemMetadata = async () => {
    const path = '/queryByGraph';
    const res = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return res;
};
export const getFiltetedItemsByType = async (objectTypeId, params) => {
    const path = `/getByType/${objectTypeId}`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: params,
    });
    return res;
};
export const getItemsByType = async (objectTypeId) => {
    const path = `/${objectTypeId}`;
    const res = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return res;
};
export const getAdjacent = async ({ sourceNode, edgeParams, ExclusiveStartKey, Limit }) => {
    const path = `/getAdjacent`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: { sourceNode, edgeParams, ExclusiveStartKey, Limit },
    });
    return res;
};
export const getCustomerDevices = async (request) => {
    const path = `/customerDevices`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: request,
    });
    return res;
};
export const reloadFromDatabase = async (request = {}) => {
    const path = `/system/reloadFromDatabase`;
    const res = await HttpApiGateway.post({
        host,
        path,
        data: request,
    });
    return res;
};
export const persistToS3 = async (request = {}) => {
    const path = `/persistToS3`;
    const res = await HttpApiGateway.get({
        host,
        path,
        data: request,
    });
    return res;
};
export const snsAWOLTest = async () => {
    const path = '/test/snsAWOL';
    const res = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return res;
};
export const dynamoDBQueryTest = async () => {
    const path = '/test/query';
    const res = await HttpApiGateway.get({
        host,
        path,
        data: undefined,
    });
    return res;
};
/** via axios client and interceptor */
export const getServerInfo2 = async () => {
    const path = '/serverInfo';
    const url = new URL(`https://${host}${path}`);
    const credentials = await Auth.currentUserCredentials();
    const axiosClient = getAxiosClient({
        apiUrl: new URL(`https://${host}${path}`),
        credentials,
        region,
    });
    const serverInfoRes = await axiosClient.get(url.toString());
    console.log({ serverInfoRes });
    let result = { err: null, data: null };
    if (serverInfoRes.status === 200) {
        debug && console.log('RES', serverInfoRes.data);
        result = serverInfoRes.data;
    }
    debug && console.log(`${path} res`, { result });
    return result;
};
